export const isVideoConsultationAvailable = (specialist) => {
    return specialist.isVideoAllowed;
};

export const queryObjectToQueryString = (object) => {
    const params = Object.keys(object).reduce((acc, key) => {
        const value = object[key];
        const serializedValue = typeof value === 'object' ? JSON.stringify(value) : value;
        const encodedValue = encodeURIComponent(serializedValue);
        if (value && key) {
            acc.push(`${key}=${encodedValue}`);
        }
        return acc;
    }, []);

    return params.join('&');
};

export const getLink = (pathName, query) => {
  const search = queryObjectToQueryString(query);
  return `${pathName}?${search}`;
};



// WEBPACK FOOTER //
// ./src/client/utils/helpers.js